import React, { useEffect } from 'react';
import { Form, Input, Button, message, notification, Select,Space,InputNumber } from 'antd';
import { MinusCircleFilled,PlusOutlined,MinusCircleOutlined } from '@ant-design/icons';
import { useCreateUserAdminPMutation, useUpdateUserAdminPMutation } from '../../../slices/adminApiSlice';
import { useCreateSubAdminPMutation, useUpdateSubAdminPMutation } from '../../../slices/subscriptionApiSlice';

const SubForm = ({ sub, getSubs, onClose }) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const [createSub, { isLoading: isNewLoading }] = useCreateSubAdminPMutation();
  const [updateSub, { isLoading: isUpdateLoading }] = useUpdateSubAdminPMutation();


  useEffect(() => {
    form.resetFields();
    if (sub) {
      form.setFieldsValue(sub);
    }
  }, [sub, form]);

  const createsub = async (newSub) => {
    try {
      const res = await createSub(newSub).unwrap();
      message.success('Package added successfully');
      getSubs();
    } catch (err) {
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  }

  const updatesub = async (updatedSub) => {
    try {
      const res = await updateSub(updatedSub).unwrap();
      message.success('Package updated successfully');
      getSubs();
    } catch (err) {
      // console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  }

  // const addUserMutation = useMutation(async (newSub) => {
  //   await axios.post('/api/users', newSub);
  //   message.success('User added successfully');
  //   refetch();
  //   onClose();
  // });

  // const updateUserMutation = useMutation(async (updatedSub) => {
  //   await axios.put(`/api/users/${sub._id}`, updatedSub);
  //   message.success('User updated successfully');
  //   refetch();
  //   onClose();
  // });

  const handleSubmit = (values) => {
    if (sub) {
      updatesub(values);
    } else {
      createsub(values);
    }
  };

  return (
    <>
    {contextHolder}
    <Form form={form} layout="vertical" onFinish={handleSubmit}>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="name" label="Name" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      {/* <Form.Item name="price" label="Price" rules={[{ required: true}]}>
        <Input type='number'/>
      </Form.Item>
      <Form.Item name="months" label="Months" rules={[{ required: true}]}>
        <Input type='number'/>
      </Form.Item>
      <Form.Item name="extradays" label="Extra Days" rules={[{ required: true}]}>
        <Input type='number'/>
      </Form.Item> */}
      <Form.Item name="price" label="Price" rules={[{ required: true }]}>
  <InputNumber style={{ width: '100%' }} />
</Form.Item>

<Form.Item name="months" label="Months" rules={[{ required: true }]}>
  <InputNumber style={{ width: '100%' }} />
</Form.Item>

<Form.Item name="extradays" label="Extra Days" rules={[{ required: true }]}>
  <InputNumber style={{ width: '100%' }} />
</Form.Item>

       {/* ✅ Tagline */}
        <Form.Item name="tagline" label="Tagline">
          <Input placeholder="Enter package tagline" />
        </Form.Item>

        {/* ✅ Editable Highlights */}
        <Form.List name="highlights">
          {(fields, { add, remove }) => (
            <>
              <label>Highlights</label>
              {fields.map(({ key, name, ...restField }) => (
                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  <Form.Item
                    {...restField}
                    name={name}
                    rules={[{ required: true, message: 'Please enter a highlight' }]}
                  >
                    <Input placeholder="Enter highlight" />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button type="dashed" onClick={() => add('')} block icon={<PlusOutlined />}>
                  Add Highlight
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>

      <Form.Item name="active" label="Active" rules={[{ required: true}]}>
        <Select 
          options={[
            {
              value: true,
              label: 'Active',
            },
            {
              value: false,
              label: 'Inactive',
            },
          ]}
        />
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" loading={sub ? isUpdateLoading : isNewLoading}   className="gold-btn"
>
          {sub ? 'Update' : 'Add'} Package
        </Button>
      </Form.Item>
    </Form>
    </>
  );
};

export default SubForm;
